function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Icon-L-External_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h18v18H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Icon-L-External_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.5 11.25a.75.75 0 01-1.5 0V7.06l-6.22 6.22a.75.75 0 01-1.06-1.06L10.94 6H6.75a.75.75 0 010-1.5h6a.75.75 0 01.75.75z"
}));

var SvgIconLExternal = function SvgIconLExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6bm9uZTt9LmJ7b3BhY2l0eToxO2NsaXAtcGF0aDp1cmwoI2EpO30uY3tvcGFjaXR5OjA7fTwvc3R5bGU+PGNsaXBQYXRoIGlkPSJhIj48cmVjdCBjbGFzcz0iYSIgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4Ii8+PC9jbGlwUGF0aD48L2RlZnM+PGcgY2xhc3M9ImIiPjxyZWN0IGNsYXNzPSJjIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiLz48cGF0aCBkPSJNMTUsMTIuNzVhLjc1Ljc1LDAsMCwxLTEuNSwwVjguNTZMNy4yOCwxNC43OEEuNzUuNzUsMCwwLDEsNi4yMiwxMy43Mmw2LjIyLTYuMjJIOC4yNWEuNzUuNzUsMCwwLDEsMC0xLjVoNmEuNzUuNzUsMCwwLDEsLjc1Ljc1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEuNSAtMS41KSIvPjwvZz48L3N2Zz4K";
export { SvgIconLExternal as ReactComponent };